import { SVGProps } from 'react';

export const HomeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
    <path
      d="M4 10.7L12 4.2l8 6.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.7"
    />
    <path
      d="M6 9.4V19a1 1 0 0 0 1 1h3.2v-4.6a1 1 0 0 1 1-1h1.6a1 1 0 0 1 1 1V20H17a1 1 0 0 0 1-1V9.4"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.7"
    />
  </svg>
);
